import axios from 'axios';

const API_BASE_AGENTS = process.env.REACT_APP_SKYCOMMS_API + '/agents';

export const apiAgents = axios.create({
  baseURL: API_BASE_AGENTS,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});